<template>
    <div class="cnkiList">
        <List ref="list" :orderByData="orderByData" :totalNum="totalNum">
            <template slot="list">
                <div v-for="(item, index) in list" :key="index" class="con">
                    <h4>
                        <router-link
                            v-html="index + 1 + ' . ' + item.ti"
                            :to="{ path: '/cnkiDetails', query: { url: decodeURIComponent(item.url) } }"
                            class="homePan"
                        >
                        </router-link>
                    </h4>
                    <div>
                        <p>
                            发表时间:<span>{{ item.postdate }}</span>
                        </p>
                        <p>
                            作者:<span>{{ item.au }}</span>
                        </p>
                        <p>
                            来源:<span>{{ item.so }}</span>
                        </p>
                        <p style="display:inline-block;width:50%">
                            下载次数:<span>{{ item.downloadNum }}</span>
                        </p>
                        <p style="display:inline-block;width:50%">
                            被引次数:<span>{{ item.citedNum }}</span>
                        </p>
                    </div>
                </div>
            </template>

            <template slot="listLeft">
                <van-collapse v-model="activeName" accordion @change="collapseChange">
                    <van-collapse-item v-for="(item, index) in facetList" :key="index" :title="item.name" :name="item.field">
                        <p style="text-align:center;padding: 10px 0;" v-show="shoeP">
                            暂无数据
                        </p>
                        <van-loading size="24px" v-show="shoeLo">加载中...</van-loading>
                        <van-radio-group v-model="facetRadio">
                            <van-radio
                                v-for="(item1, index1) in facetData.list"
                                :key="index1"
                                :name="item1.key"
                                @click="facetCickL(facetData.groupId, item1.key)"
                            >
                                {{ item1.label }}<span style="float: right;">{{ item1.value }}</span>
                            </van-radio>
                        </van-radio-group>
                    </van-collapse-item>
                </van-collapse>
                <van-button type="info" block @click="cancel()">清除筛选</van-button>
            </template>
        </List>
    </div>
</template>
<script>
import api from "@/request/api";
import List from "@/components/list.vue";
// import { Toast } from 'vant'
export default {
    data() {
        return {
            valType: "",
            list: [], // 列表  1
            activeName: 0,
            page: 1,
            pageShow: false,
            data: {},
            facetData: {},
            orderByData: [
                // { title: "相关度", value: "RELEVANT" },
                // { title: "发表时间", value: "PT" },
                // { title: "被引", value: "CITY" },
                // { title: "下载", value: "DOWNLOAD" },
                // { title: "综合", value: "ALL" }
                { title: "相关性", value: "FFD" },
                { title: "发表时间", value: "PT" },
                { title: "被引", value: "CF" },
                { title: "下载", value: "DFR" },
                { title: "综合", value: "ZH" }
            ], // 排序数据
            totalNum: 0, // 检索总数据
            facetList: [
                { field: 1, name: "主题词类别" },
                { field: 2, name: "学科" },
                { field: 3, name: "年份" },
                { field: 4, name: "研究层次" },
                { field: 6, name: "文献来源" },
                { field: 7, name: "作者" },
                { field: 8, name: "机构" },
                { field: 9, name: "基金" }
            ], // 分面数据
            shoeP: false, // 筛选暂无数据显示隐藏
            shoeLo: false, // 筛选加载中显示隐藏
            eiRefineData: {
                facetTerm: "",
                sortBy: "relevance|dw"
            }, // 分维度选择检索接口
            facetRadio: 0 //1
        };
    },
    components: {
        List
    },
    mounted() {
        this.data = this.$route.query;
        this.search();
        this.$store.dispatch("actionsHead", { type: true, title: "中国知网", iconType: true });
    },
    methods: {
        search() {
            api.search("cnki", this.data).then((response) => {
                this.$refs.list.onLoadShow = true;
                if (response.code == 0) {
                    if (response.data.list.length == 0) {
                        this.$refs.list.listShow = true;
                    } else {
                        this.$refs.list.listShow = false;
                        if (this.data.page > 1) {
                            this.list = this.list.concat(response.data.list);
                        } else {
                            this.list = response.data.list;
                        }
                        this.totalNum = response.data.total;
                    }
                    if (this.valType == "left") {
                        this.$refs.list.listLefShow = false;
                    } else if (this.valType == "right") {
                        this.$refs.list.listRightShow = false;
                    }
                } else if (response.code == -99) {
                    this.$refs.list.error = true;
                }
            });
        },
        onLoad() {
            this.$refs.list.onLoadShow = false;
            this.data.page = Number(this.data.page) + 1;
            this.search();
        },
        facetCickL(field, label) {
            this.data.facetTerm = field + "-" + label;
            this.valType = "left";
            this.data.page = 1;
            this.search();
        },
        orderByCick(val) {
            this.data.page = 1;
            this.data.orderBy = val;
            this.$refs.list.listCurrent = val;
            this.search();
            this.valType = "right";
        },
        collapseChange(e) {
            if (e) {
                api.facet("cnki", { type: e }).then((response) => {
                    if (response.code == 0) {
                        this.facetData = response.data;
                        this.shoeLo = false;
                        if (response.data.list.length == 0) {
                            this.shoeP = true;
                        } else {
                            this.shoeP = false;
                        }
                    }
                });
            }
        },
        cancel() {
            this.data.page = 1;
            this.facetRadio = -1;
            this.data.facetTerm = "";
            this.search();
            this.$refs.list.listLefShow = false;
        }
        //   cancel() {
        //     this.page = 1;
        //     this.currentLeft = -1;
        //     this.LeftType = "";
        //     this.getSearch();
        //     this.showL = false;
        // }
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === "cnkiDetails") {
            if (!from.meta.keepAlive) {
                from.meta.keepAlive = true; // 当我们进入到C时开启B的缓存
            }
            to.meta.keepAlive = true; // 当我们进入到C时开启B的缓存
            next();
        } else {
            from.meta.keepAlive = false;
            //   this.$vnode.parent.componentInstance.cache = {};
            //   this.$vnode.parent.componentInstance.keys = [];
            this.$destroy();
            next(); // 当我们前进的不是C时我们让B页面刷新
        }
    }
};
</script>
<style lang="less">
.cnkiList {
    margin-top: 0.8rem;

    .van-row {
        border-bottom: 1px solid #e3e3e3;
        height: 2.5rem;
        padding: 0.7rem 0;
        background: #fff;

        .van-col--12 {
            color: #0c60a3;
            text-align: center;
        }
    }

    > p {
        font-size: 0.6rem;
        padding: 0.8rem 1rem;
        color: #b0b0b0;
        background: #fff;
    }

    .listCon {
        margin-top: 0.8rem;
        background: #fff;

        > p {
            padding: 1rem 1rem 0 1rem;
            color: #9a9a9a;
        }

        .van-list {
            .con {
                border-bottom: 1px solid #e3e3e3;
                padding: 1rem;

                h4 {
                    a {
                        color: #0c60a3;
                    }

                    font-weight: 400;
                }

                p {
                    margin-bottom: 0.4rem;

                    span {
                        color: #9a9a9a;
                    }
                }
            }
        }
    }
}
.van-popup {
    .van-collapse {
        height: 35rem;
        overflow: auto;
    }
    .van-button--block {
        position: fixed;
        bottom: 0;
    }
}
</style>
